import { useMemo } from 'react';
import useDecorateHandlerWithTracking from './useDecorateHandlerWithTracking';
export default function useTrackCampaignSelectInteraction({
  applicationId,
  enableTracking,
  handleCampaignAutoSelectChange,
  handleSelectedOptionChange
}) {
  const eventKey = 'campaignSelectInteraction';
  const handleCampaignAutoSelectChangeWithTracking = useDecorateHandlerWithTracking({
    eventKey,
    filterFn: campaignToAutoSelect => Boolean(campaignToAutoSelect),
    handler: handleCampaignAutoSelectChange,
    properties: {
      applicationId,
      action: 'auto select a campaign'
    },
    additionalPropertiesFn: campaignToAutoSelect => {
      const campaignValue = campaignToAutoSelect && Array.isArray(campaignToAutoSelect) ? campaignToAutoSelect[0] : campaignToAutoSelect;
      if (campaignValue) {
        return {
          campaignId: campaignValue.guid,
          assetId: campaignValue.objectId
        };
      }
      return {};
    }
  });
  const handleSelectedOptionChangeWithTracking = useDecorateHandlerWithTracking({
    eventKey,
    filterFn: ({
      target: {
        value
      }
    }) => Boolean(value),
    handler: handleSelectedOptionChange,
    properties: {
      applicationId,
      action: 'select a campaign'
    },
    additionalPropertiesFn: ({
      target: {
        value
      }
    }) => {
      const campaignValue = Array.isArray(value) ? value[0] : value;
      if (Array.isArray(value)) {
        return {
          containsSearchQuery: Boolean(value.some(val => val.containsSearchQuery)),
          isRecentlyUsed: Boolean(value.some(val => val.isRecentlyUsed)),
          campaignId: campaignValue === null || campaignValue === void 0 ? void 0 : campaignValue.guid,
          assetId: campaignValue === null || campaignValue === void 0 ? void 0 : campaignValue.objectId
        };
      }
      return {
        containsSearchQuery: Boolean(value.containsSearchQuery),
        isRecentlyUsed: Boolean(value.isRecentlyUsed),
        campaignId: campaignValue === null || campaignValue === void 0 ? void 0 : campaignValue.guid,
        assetId: campaignValue === null || campaignValue === void 0 ? void 0 : campaignValue.objectId
      };
    }
  });
  return useMemo(() => {
    if (enableTracking) {
      return {
        handleCampaignAutoSelectChangeWithTracking,
        handleSelectedOptionChangeWithTracking
      };
    }
    return {
      handleCampaignAutoSelectChangeWithTracking: handleCampaignAutoSelectChange,
      handleSelectedOptionChangeWithTracking: handleSelectedOptionChange
    };
  }, [enableTracking, handleCampaignAutoSelectChange, handleCampaignAutoSelectChangeWithTracking, handleSelectedOptionChange, handleSelectedOptionChangeWithTracking]);
}